import { z } from "zod";

export const fwfColumnMappingSchema = z.object({
  column: z.string(),
  offset: z.number().int().min(0),
  length: z.number().int().min(1),
});

export type FwfColumnMapping = z.infer<typeof fwfColumnMappingSchema>;

export const fwfOptionsSchema = z.object({
  columnMappings: z.array(fwfColumnMappingSchema),
});

export type FwfOptions = z.infer<typeof fwfOptionsSchema>;
